var $ = require('jquery');
$(document).ready(function () {
    function openCity(evt, cityName) {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("tabcontent");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";
        }
        tablinks = document.getElementsByClassName("tablinks");
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active", "");
        }
        document.getElementById(cityName).style.display = "block";
        evt.currentTarget.className += " active";
    }
    $(".tablinks").click(function (e) {
        var datat = $(this).attr("data-target");
        openCity(e, datat);
    })
    // Get the element with id="defaultOpen" and click on it
    if($(".tablinks").length>0)
    {
        $(".tablinks")[0].click();
    }
    
})
$(document).ready(function () {
    //var profile_values = document.getElementsByClassName('article-wrap');
    if ($('.insights-article-main-sec').length > 0) {
        var profile_values = document.getElementsByClassName('article-content-wrap');
        var total = 0;
        for (var i = 0; i < profile_values.length; i += 1) {
            total += profile_values[i].innerHTML.trim().split(" ").length
        }
        var timeToread = Math.round(total / 850);
        $('.read-time').html('| ' + timeToread + ' min read ');
        var Title = $('.article-title').attr('data-title');
        var mailDesc = $('.article-mailDesc').attr('data-description');
        var location = window.location.href;
        var attachment = $('.article-attachment').attr('data-attach');
        var fbDesc = $('.article-fbDesc').attr('data-description');
        var bimg = $('.article-bgimg').attr('data-img');
        var curUrl = $('.article-currenturl').attr('data-url');
        var linkedIndescription = $('.article-linkedinDesc').attr('data-description');

        if ($('.insights-article-main-sec').length != -1) {
            if ($('.pdf-data').length > 0) {
                attachment = $('.pdf-data').attr('href');
            }
            if (Title == "" || Title == "null") {
                Title = mailDesc;
            }
            if (mailDesc == "" || mailDesc == "null") {
                mailDesc = "Please read below interesting content from Eastspring Investments "
            }
            if (attachment == "" || attachment == "null") {
                $('.pdf').hide();
            }
            else {
                $('.pdf').show();
                $('.pdf').eq(0).attr("href", attachment);

            }
        }
        //$('.fb').eq(0).attr("href", "JavaScript:postToFeed('" + Title.replace("'", "\\'") + "','" + fbDesc + "','" + bimg + "','" + curUrl + "')");
        //$('.tw').eq(0).attr("href", "JavaScript:TwitterShare('" + Title.replace("'", "\\'") + "', '" + location + "')");
        $('.lin').attr("href", "https://www.linkedin.com/shareArticle?mini=true&url=" + location + "&title=" + (Title.replace("'", "")) + "&summary=" + linkedIndescription);
        // $('.mai').eq(0).attr("href", "javascript:sendMail('" + Title.replace("'", "") + "','" + mailDesc + "','" + location + "')");
        $('.app').attr("href", "JavaScript:WhatsApp('" + Title.replace("'", "\\'") + "','" + location + "');");
        $('.line1').attr("href", "https://social-plugins.line.me/lineit/share?url=" + location);
        //$('.print').click(function () {
        //    $('.container-fluid').print();
        //});
        $('.fb').click(function (e) {
            e.preventDefault();
            postToFeed(Title, fbDesc, bimg, curUrl);
        });
        $('.tw').click(function (e) {
            e.preventDefault();
            TwitterShare(Title, location);
        });
        $('.mai').click(function (e) {
            e.preventDefault();
            sendMail(Title, mailDesc, location);
        })

        var requrl = $(location).attr('href').toLowerCase();
        if (requrl.indexOf("action/edit") > 0) {
            $('.noItem').show();
        }
        else {
            $('.noItem').hide();
        }
        // $('.fb').eq(1).attr('href', $('.fb').eq(0).attr('href'));
        //$('.tw').eq(1).attr('href', $('.tw').eq(0).attr('href'));
        //$('.lin').eq(1).attr('href', $('.lin').eq(0).attr('href'));
        // $('.mai').eq(1).attr('href', $('.mai').eq(0).attr('href'));
        //$('.app').eq(1).attr('href', $('.app').eq(0).attr('href'));
        // $('.pdf').eq(1).attr('href', $('.pdf').eq(0).attr('href'));
        //$('.line1').eq(1).attr('href', $('.line1').eq(0).attr('href'));
        var attachUrl = $('.pdf').eq(0).attr('href');
        if ($('.pdf').length > 1) {
            if (attachUrl == "" || attachUrl == "null") {
                $('.pdf').eq(1).hide();
            }
        }
        else { $('.pdf').hide(); }
    }

});
function mailTo(Title, Description) {
    //    var title = $(this).attr('title');
    $('.hideSlide').attr('href', 'mailto:eastspring.global@gmail.com?subject=' + Title + '&body=' + Description);
    GTMSocialShare('Email');
};
function sendMail(sub, body, filepath) {
    //var a = document.createElement("a");
    //a.href = "mailto:?subject=" + escape(sub.toString()) + "&body=Hi, %0D%0A %0D%0A" + body + "%0D%0A " + filepath;
    //a.click();
    var requestedurl = $(location).attr('href').toLowerCase();
    if (requestedurl.indexOf('zh-cht') > 0 || requestedurl.indexOf('kr') > 0 || requestedurl.indexOf('th') > 0) {
        document.location.href = "mailto:?subject=" + encodeURI(sub.toString()).toString().replace(/&/gi, '%26') + "&body=Hi, %0D%0A %0D%0A" + body + "%0D%0A" + filepath + " %0D%0A";
    }
    else {
        document.location.href = "mailto:?subject=" + escape(sub.toString()) + "&body=Hi, %0D%0A %0D%0A" + body + "%0D%0A " + filepath + " %0D%0A";
    }
    GTMSocialShare('Email');
}
function WhatsApp(Content, url) {
    var message = encodeURIComponent(Content.replace("&#39;", "'")) + ', ' + encodeURIComponent(url) + '';
    var whatsapp_url = "https://web.whatsapp.com/send?text=" + message;
    window.location.href = whatsapp_url;
    GTMSocialShareMP('Whatsapp');
}
function BuildStr(value) {
    if (value != '' && value != null) {
        return value.replace(/%/gi, '%25').replace(/#/gi, '%23').replace(/;/gi, '%3B').replace(/"/gi, '%22').replace("'", "\'").replace(/\./g, '%2E').replace(/&/gi, '%26')
    } else { return ''; }
}
function TwitterShare(description, url) {
    var accessToken = 'cebfde270cd918f84d432b03f4364e6c1d0e44ab', result;  //'02ee2b5bc478c512e0b0a0fd639201521a088cef';
    var hostName = "http://" + window.location.hostname; //'http://esdev.devtpit.com/';
    // alert(url);
    var url = 'https://api-ssl.bitly.com/v3/shorten?access_token=' + accessToken + '&longUrl=' + encodeURIComponent(url);
    $.getJSON(
        url, {}, function (response) {
            result = response.data.url;
            description = description.replace(/�/g, "");
            var requestedurl = $(location).attr('href').toLowerCase();
            var tempurl = '';
            //if (requestedurl.indexOf('zh-cht') > 0)
            //    tempurl = 'https://twitter.com/intent/tweet?text=' + encodeURI(description) + ' ' + result;
            //else
            //    tempurl = 'https://twitter.com/intent/tweet?text=' + escape(description) + ' ' + result;
            tempurl = 'https://twitter.com/intent/tweet?text=' + encodeURI(description.toString()).toString().replace(/&/gi, '%26') + ' ' + result;
            popupWindow = window.open(tempurl, 'popUpWindow', 'height=400,width=600,left=300,top=80,resizable=no,scrollbars=no,toolbar=yes,menubar=no,location=no,directories=no,status=no')
        }
    );
    // Sharingwebtrend('Twitter', description); //Webtrends Social Media Sharing
    GTMSocialShare('Twitter');
}
function newPopup(urlasp, bitlyurl) {
    // alert("hello");
    var accessToken = 'cebfde270cd918f84d432b03f4364e6c1d0e44ab';  //'02ee2b5bc478c512e0b0a0fd639201521a088cef';
    var popurl = 'https://twitter.com/intent/tweet?text=' + BuildStr(urlasp) + '%20' + bitlyurl;
    popupWindow = window.open(popurl, 'popUpWindow', 'height=400,width=600,left=300,top=80,resizable=no,scrollbars=no,toolbar=yes,menubar=no,location=no,directories=no,status=no');
}

var FBID_Devt = "770225153110456";   // http://esdev.devtpit.com/
var FBID_stage = "1075450029132843"; //http://www.eastspring.com/
var FBID_Live = "594031947405949";  //http://eastspring.com/
if (window.location.href.indexOf(".th") > -1) {
    FBID_Live = "157482543131437";
}
window.fbAsyncInit = function () {
    FB.init({
        appId: FBID_Live, status: true, cookie: true,
        version: 'v2.2'
    });
};

(function (d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) { return; }
    js = d.createElement(s); js.id = id;
    js.src = "//connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

function shareContent() {
    // Build the JSON payload containing the content to be shared
    var payload = {
        "comment": "Check out developer.linkedin.com! http://linkd.in/1FC2PyG",
        "visibility": {
            "code": "anyone"
        }
    };

    IN.API.Raw("/people/~/shares?format=json")
        .method("POST")
        .body(JSON.stringify(payload))
        .result(onSuccess)
        .error(onError);
}
function onLinkedInLoad() {
    IN.Event.on(IN, "auth", shareContent);
}

function onSuccess(data) {
    console.log(data);
}

// Handle an error response from the API call
function onError(error) {
    console.log(error);
}
function postToFeed(Title, Description, Img, HostName) {
    // calling the API ...
    // HostName = "http://esdev.devtpit.com/";
    Title = Title.replace(/�/g, "");
    Title = unescape(Title);
    var fbtitle = Title;
    var fbdes = Description;
    //var obj1 = "Nag";
    var fbimg;
    if (Img != '' && Img != null)
        fbimg = Img;
    else
        fbimg = window.location.origin + '/logos/socialsharelogo.png';
    var obj = {
        method: 'feed',
        link: HostName,
        picture: fbimg,
        name: fbtitle,
        // caption: fbdes,
        description: fbdes
    };
    FB.ui(obj);
    //Sharingwebtrend('Facebook', Title); //Webtrends Social Media Sharing
    GTMSocialShare('Facebook');
}
$('.icon-link.lin').click(function () {
    GTMSocialShare('LinkedIn');
});
var articleCategory = "article";
if (window.location.href.indexOf("money-parenting") > -1) {
    articleCategory = "article_MP"
}

function GTMSocialShare(socialShare) {
    dataLayer.push({
        'event': 'trackEvent',
        'eventDetails.category': articleCategory,
        'eventDetails.action': 'share',
        'eventDetails.label': socialShare //or twitter, linkedin, mail
    });
}

//regarding MP site
function postToFeedMP(Title, Description, Img, HostName) {
    // calling the API ...
    // HostName = "http://esdev.devtpit.com/";
    Title = Title.replace(/�/g, "");
    Title = unescape(Title);
    var fbtitle = Title;
    var fbdes = Description;
    //var obj1 = "Nag";
    var fbimg;
    if (Img != '' && Img != null)
        fbimg = Img;
    else
        fbimg = window.location.origin + '/logos/socialsharelogo.png';
    var obj = {
        method: 'feed',
        link: HostName,
        picture: fbimg,
        name: fbtitle,
        // caption: fbdes,
        description: fbdes
    };
    FB.ui(obj);
    //Sharingwebtrend('Facebook', Title); //Webtrends Social Media Sharing
    GTMSocialShareMP('Facebook');
}
function TwitterShareMP(description, url) {
    var accessToken = 'cebfde270cd918f84d432b03f4364e6c1d0e44ab', result;  //'02ee2b5bc478c512e0b0a0fd639201521a088cef';
    var hostName = "http://" + window.location.hostname; //'http://esdev.devtpit.com/';
    // alert(url);
    var url = 'https://api-ssl.bitly.com/v3/shorten?access_token=' + accessToken + '&longUrl=' + encodeURIComponent(url);
    $.getJSON(
        url, {}, function (response) {
            result = response.data.url;
            description = description.replace(/�/g, "");
            var requestedurl = $(location).attr('href').toLowerCase();
            var tempurl = '';
            //if (requestedurl.indexOf('zh-cht') > 0)
            //    tempurl = 'https://twitter.com/intent/tweet?text=' + encodeURI(description) + ' ' + result;
            //else
            //    tempurl = 'https://twitter.com/intent/tweet?text=' + escape(description) + ' ' + result;
            tempurl = 'https://twitter.com/intent/tweet?text=' + encodeURI(description.toString()).toString().replace(/&/gi, '%26') + ' ' + result;
            popupWindow = window.open(tempurl, 'popUpWindow', 'height=400,width=600,left=300,top=80,resizable=no,scrollbars=no,toolbar=yes,menubar=no,location=no,directories=no,status=no')
        }
    );
    // Sharingwebtrend('Twitter', description); //Webtrends Social Media Sharing
    GTMSocialShareMP('Twitter');
}
function sendMailMP(sub, body, filepath) {
    //var a = document.createElement("a");
    //a.href = "mailto:?subject=" + escape(sub.toString()) + "&body=Hi, %0D%0A %0D%0A" + body + "%0D%0A " + filepath;
    //a.click();
    var requestedurl = $(location).attr('href').toLowerCase();
    if (requestedurl.indexOf('zh-cht') > 0 || requestedurl.indexOf('kr') > 0) {
        document.location.href = "mailto:?subject=" + encodeURI(sub.toString()).toString().replace(/&/gi, '%26') + "&body=Hi, %0D%0A %0D%0A" + body + "%0D%0A" + filepath + " %0D%0A";
    }
    else {
        document.location.href = "mailto:?subject=" + escape(sub.toString()) + "&body=Hi, %0D%0A %0D%0A" + body + "%0D%0A " + filepath + " %0D%0A";
    }
    GTMSocialShareMP('Email');
}
$('.icon-link.lin.mp-link').click(function () {
    GTMSocialShareMP('LinkedIn');
});
var url = $(location).attr('href'),
    parts = url.split("/"),
    last_part = parts[parts.length - 1];
var event_category = last_part.split('?')[0];


function GTMSocialShareMP(socialShare) {
    dataLayer.push({
        'event': 'trackEvent',
        'eventDetails.category': event_category,
        'eventDetails.action': 'share',
        'eventDetails.label': socialShare //or twitter, linkedin, mail
    });
}
